import React, { useState } from "react";
import MonkCapitalLogo from "../../../images/monk_capital_logo_edit.png";
import FeemonkLogo from "../../../../images/feemonk-logo.png";
import styles from "./index.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const isEligibilityFlow = location.pathname.startsWith("/eligibility");

  const handleLogout = () => setShowLogoutDialog(true);

  const confirmLogout = () => {
    setShowLogoutDialog(false);
    sessionStorage.removeItem("eligibility_auth_token");
    navigate("/eligibility/login");
  };

  return (
    <>
      {showLogoutDialog && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "1.8rem 1.5rem 1.4rem",
              width: "min(88vw, 320px)",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "0.5rem",
              fontFamily: "Outfit, sans-serif",
            }}
          >
            <div
              style={{
                width: "2.8rem",
                height: "2.8rem",
                borderRadius: "50%",
                background: "#fde8e8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "0.4rem",
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                  stroke="#d32028"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 17L21 12L16 7"
                  stroke="#d32028"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21 12H9"
                  stroke="#d32028"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <p
              style={{
                margin: 0,
                fontSize: "1rem",
                fontWeight: 700,
                color: "#1a1a1a",
                textAlign: "center",
              }}
            >
              Logout?
            </p>
            <p
              style={{
                margin: "0.2rem 0 0.9rem",
                fontSize: "0.85rem",
                color: "#777",
                textAlign: "center",
                lineHeight: 1.5,
              }}
            >
              Are you sure you want to logout?
            </p>
            <div style={{ display: "flex", gap: "0.75rem", width: "100%" }}>
              <button
                onClick={() => setShowLogoutDialog(false)}
                style={{
                  flex: 1,
                  padding: "0.7rem",
                  border: "1.5px solid #e0e0e0",
                  borderRadius: "60px",
                  background: "#fff",
                  color: "#555",
                  fontSize: "0.88rem",
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: "Outfit, sans-serif",
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmLogout}
                style={{
                  flex: 1,
                  padding: "0.7rem",
                  border: "none",
                  borderRadius: "60px",
                  background: "#d32028",
                  color: "#fff",
                  fontSize: "0.88rem",
                  fontWeight: 700,
                  cursor: "pointer",
                  fontFamily: "Outfit, sans-serif",
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
      {isEligibilityFlow ? (
        <div
          style={{
            display: "flex",
            height: "7rem",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              maxWidth: "400px",
              padding: "0 1rem",
              boxSizing: "border-box",
              marginRight: "-2rem",
            }}
          >
            <img
              src={
                location?.state?.data?.channelId === 5
                  ? MonkCapitalLogo
                  : FeemonkLogo
              }
              alt=""
              style={{ width: "8rem", marginTop: "-1rem" }}
            />
            {isEligibilityFlow &&
              location.pathname !== "/eligibility/login" && (
                <button onClick={handleLogout} className={styles.logoutBtn}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16 17L21 12L16 7"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M21 12H9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Logout
                </button>
              )}
          </div>
        </div>
      ) : (
        <div className={styles.navbar}>
          <img
            style={{
              width: "10rem",
              height: location?.state?.data?.channelId === 5 ? "2rem" : "auto",
            }}
            src={
              location?.state?.data?.channelId === 5
                ? MonkCapitalLogo
                : FeemonkLogo
            }
            alt=""
            className={styles.logo}
          />
        </div>
      )}
    </>
  );
}

export default Navbar;
